import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import {
  trigger,
  style,
  animate,
  transition,
  query,
  stagger,
  keyframes,
  state,
  group,
} from "@angular/animations";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
import {PlatformLocation} from '@angular/common';
import {StoreService} from '../store.service';

declare var $: any;

@Component({
  selector: "app-case-practice-report-new",
  animations: [
    trigger("bestPathBoxAnimation", [
      state("hideBestPathBox", style({ opacity: 0, transform: "scale(0, 0)" })),
      state("showBestPathBox", style({ opacity: 1, transform: "scale(1, 1)" })),
      transition(
        "hideBestPathBox => showBestPathBox",
        animate(
          "200ms",
          keyframes([
            style({ transform: "scale(0.1, 0.1)", opacity: 0.1 }),
            style({ transform: "scale(0.2, 0.2)", opacity: 0.2 }),
            style({ transform: "scale(0.3, 0.3)", opacity: 0.3 }),
            style({ transform: "scale(0.4, 0.4)", opacity: 0.4 }),
            style({ transform: "scale(0.5, 0.5)", opacity: 0.5 }),
            style({ transform: "scale(0.6, 0.6)", opacity: 0.6 }),
            style({ transform: "scale(0.7, 0.7)", opacity: 0.7 }),
            style({ transform: "scale(0.8, 0.8)", opacity: 0.8 }),
            style({ transform: "scale(0.9, 0.9)", opacity: 0.9 }),
            style({ transform: "scale(1, 1)", opacity: 1 }),
          ])
        )
      ),
      transition(
        "showBestPathBox => hideBestPathBox",
        animate(
          "200ms",
          keyframes([style({ opacity: 1 }), style({ opacity: 0 })])
        )
      ),
    ]),
    trigger("analysisBoxAnimation", [
      state(
        "hideAnalysisBox",
        style({ opacity: 0, transform: "translate(-100%)" })
      ),
      state("showAnalysisBox", style({ opacity: 1 })),
      transition(
        "hideAnalysisBox => showAnalysisBox",
        animate(
          "200ms",
          keyframes([
            style({
              transform:
                "matrix3d(0.08700000000000001,-0.09,0.50,0,0.09,0.01,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "45%",
            }),
            style({
              transform:
                "matrix3d(0.43065,-0.12,0.50,0,0.12,0.2475,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "47%",
            }),
            style({
              transform:
                "matrix3d(0.6525,-0.07,0.50,0,0.07,0.6,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "49%",
            }),
            style({
              transform:
                "matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,0,0,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "50%",
            }),
          ])
        )
      ),
      transition(
        "showAnalysisBox => hideAnalysisBox",
        animate(
          "500ms",
          keyframes([style({ opacity: 1 }), style({ opacity: 0 })])
        )
      ),
    ]),
    trigger("starAnimation", [
      state("hideStar", style({ opacity: 0 })),
      state("showStar", style({ opacity: 1 })),
      transition("hideStar => showStar", [
        style({ opacity: 1 }),
        query(".starReport", style({ opacity: 0 })),
        query(".starReport5", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport4", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport3", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport2", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport1", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
      ]),
    ]),
  ],
  templateUrl: "./case-practice-report-new.component.html",
  styleUrls: [
    "./case-practice-report-new.component.css",
  ],
})
export class CasePracticeReportNewComponent implements OnInit, AfterViewInit {
  currentName: any;
  currentTotal: any;
  currentDescription: any;
  currentAnalysis: any;

  practiceId: any;
  exerciseId: any;
  learningPathId: any;

  report: any;

  //报告等级KA对象：传递给等级组件
  reportKAData: any;
  // 是否显示等级组件：用于异步渲染判断
  isShowReportLv: boolean;
  //二级标识，用于判断接口返回正常不正常：正常显示组件，不正常隐藏组件
  targetShow: any;

  // chuanjie: any;
  learningPathMetaId: any;
  learningPath: any;
  learningTour: any;
  finished: boolean;
  practiceMetaId: number;
  analysisBoxShow: boolean;
  bestPathBoxShow: boolean;
  starShow: boolean;
  reportName: string;

  tutor: any;
  optimum: any;

  mode: number;
  lvCls: string;

  starPicUrl: string;

  pathClickable: boolean;
  goToListClickedStatus: boolean;
  redoClickedStatus: boolean;

  itemClickEnable: boolean = false;
  //配置信息
  abilityConfig: AbilityConfig;
  isOpenClass: number = 0;
  assetsRoute: string = "../../assets";
  type : string
  isHarmonyOS = false; //是否鸿蒙系统
  constructor(
    private commonService: CommonService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private platformLocation: PlatformLocation,
    private router: Router,
    private storeService:StoreService
  ) {}

  ngOnInit() {
    this.isHarmonyOS = this.commonService.isHarmonyOS();
    this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
    this.abilityConfig = new AbilityConfig(this.apiService,this.commonService);
    let that = this;
    this.isShowReportLv = false;
    this.bestPathBoxShow = false;
    this.analysisBoxShow = false;
    this.starShow = false;
    this.pathClickable = true;
    this.goToListClickedStatus = false;
    this.redoClickedStatus = false;
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.route.queryParams.subscribe(queryParams=>{
      this.type=queryParams['type']
    })
    this.route.params.subscribe((params) => {
      this.practiceId = params["practiceId"];
      this.exerciseId = params["exerciseId"];
      this.learningPathId = params["learningPathId"];

      this.apiService
        .ajax({
          type: "get",
          'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId,
        })
        .subscribe((result) => {
          this.learningPathMetaId = result.data;
          this.updateExerciseReports();
        });

      this.apiService
        .ajax({
          type: "get",
          url: "/sr/learningtour",
        })
        .subscribe((result) => {
          this.learningTour = result;
        });

      this.apiService
        .ajax({
          type: "get",
          url: "/api/exerciseTutor/" + this.exerciseId,
        })
        .subscribe((result) => {
          this.tutor = result.tutor;
          this.optimum = result.optimum;
        });
    });
  }

  updateExerciseReports() {
    this.apiService
      .ajax({
        type: "get",
        url:
          "/sr/insideapi/updateExerciseReports?exerciseId=" + this.exerciseId,
      })
      .subscribe(() => {
        this.getKasInfo(this.learningPathMetaId);
      });
  }

  getKasInfo(learningPathMetaId) {
    let url = (learningPathMetaId == 11 || learningPathMetaId == 403) ?
      "sr/practice/getReports/" + this.exerciseId + "/" + this.practiceId :
      "/api/practices/" + this.exerciseId + "/" + this.practiceId + "/report";

    this.getReport(url).then(result=>{
      this.practiceMetaId = result.practiceMetaId;
      if (result.reports.length == 0) {
        this.redo();
      } else {
        this.report = result.reports[0].kas;
        this.reportName = result.reports[0].name;
        this.finished = result.allExerciseFinished;
        this.getLevelInfo(result.reports[0]);
      }
    }).catch(error =>{
      this.apiService.ajax({
        'type': 'GET',
        'url': `sr/exercises/autoReset/${this.exerciseId}`
      }).subscribe(()=>{
        this.router.navigate(["learning-path",localStorage.getItem('learningPathMetaId')]);
      })

    })
    // if(learningPathMetaId == 11 || learningPathMetaId == 403){
    //   this.apiService.ajax({
    //     type: "get",
    //     url: "sr/practice/getReports/" + this.exerciseId + "/" + this.practiceId,
    //   }).subscribe(result=>{
    //     this.practiceMetaId = result.practiceMetaId;
    //     if (result.reports.length == 0) {
    //       this.redo();
    //       // this.goToList();
    //     } else {
    //       // this.report = result.reports.kas;
    //       // this.reportName = result.reports.name;
    //       // this.finished = result.allExerciseFinished;
    //       // this.getLevelInfo(result.reports);
    //       this.report = result.reports[0].kas;
    //       this.reportName = result.reports[0].name;
    //       this.finished = result.allExerciseFinished;
    //       this.getLevelInfo(result.reports[0]);
    //     }
    //   })
    // }else{
    //   this.apiService.ajax({
    //       type: "get",
    //       url: "/api/practices/" + this.exerciseId + "/" + this.practiceId + "/report",
    //     }).subscribe((result) => {
    //       console.log(111111111111111111);
    //       console.log(result,111111111);
    //     //无报告数据转向列表页
    //     this.practiceMetaId = result.practiceMetaId;
    //     if (result.reports.length == 0) {
    //       this.redo();
    //       // this.goToList();
    //     } else {
    //       this.report = result.reports[0].kas;
    //       this.reportName = result.reports[0].name;
    //       this.finished = result.allExerciseFinished;
    //       this.getLevelInfo(result.reports[0]);
    //     }
    //   });
    // }


  }

  getLevelInfo(reports) {
    let that = this;
    $.ajax({
      url: "/sr/insideapi/getlevel",
      type: "post",
      dataType: "json",
      contentType: "application/json;charset=utf-8",
      data: JSON.stringify(this.getKaList(reports)),
      async: false,
      headers : {
        'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
        'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
      },
      success: function (result) {
        if (result && result != "") {
          that.reportKAData = result;
          that.targetShow = 1;
        } else {
          that.targetShow = 0;
        }
      },
      error: function (er) {
        if(er.status === 401 && Number(er.responseJSON.code) === 106){
          that.storeService.notification.notAuthed.next(true);
        }
        that.targetShow = 0;
      },
    });
    if (reports.name == "组织与计划") {
      this.mode = 2;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticepando/star2.png";
    } else if (reports.name == "影响力") {
      this.mode = 3;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticeteam/star_report.png";
    } else {
      this.mode = 1;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticeteam/star_report.png";
    }

    if (that.targetShow === 0) {
      this.isShowReportLv = false;
    } else {
      this.isShowReportLv = true;
    }

    setTimeout(() => {
      this.itemClickEnable = true;
    }, 500);
  }

  ngAfterViewInit() {
    let that = this;
    this.commonService.initPage({
      backgroundColor: "white",
    });
    $(document).ready(function () {
      var listenerTimeout = setInterval(function () {
        var bestPathEle = document.getElementById("bestPathBox"),
          analysisEle = document.getElementById("analysisContent"),
          tutorEle = document.getElementById("tourReviewBox");
        if (bestPathEle !== null && analysisEle !== null && tutorEle != null) {
          bestPathEle.addEventListener("scroll", that.onBestPathScroll);
          analysisEle.addEventListener("scroll", that.onAnalysisScroll);
          tutorEle.addEventListener("scroll", that.onTutorScroll);
          clearInterval(listenerTimeout);
        }
      }, 500);
    });
  }

  /*
    格式化KA对象方法
     report：传递一个报告对象
   */
  getKaList(report) {
    let kaJson = {
      id: report.id,
      name: report.name,
      type: report.type,
      kas: {},
      exercisesId: this.exerciseId,
      questionId: null,
      optionId: null,
    };
    if (window["exercises" + this.exerciseId] != null) {
      let exerciseConfig = window["exercises" + this.exerciseId];
      kaJson.questionId = exerciseConfig.questionId;
      kaJson.optionId = exerciseConfig.optionId;
    }

    if (report && Array.isArray(report.kas)) {
      for (let i = 0; i < report.kas.length; i++) {
        let kaItem = report.kas[i];
        if (kaItem) {
          //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
          kaJson.kas[kaItem.name] = kaItem.value;
        }
      }
    }else{
      kaJson = null;
      this.close();
    }
    return kaJson;
  }

  close() {
    this.apiService
      .ajax({
        type: "get",
        url: "/api/learningpathes/" + this.learningPathId,
      })
      .subscribe((result) => {
        //转向情景列表
        let link = this.abilityConfig.getPracticeLinkList(
          result.name,
          this.learningPathId,
          this.practiceMetaId
        );

        if(localStorage.getItem('openClass')){
          let href = '';
          link.forEach((v)=>{
            href+='/'+v
          })
          href = href+'#isShowBack=0';
          this.platformLocation['location']['href'] = this.platformLocation['location']['origin']+href;
        }else{
          if (link.length > 0) {
            if(this.type){
              this.router.navigate(link,{queryParams:{type:'huatek'}});
            }else{
              this.router.navigate(link);
            }
          }
        }
      });
  }

  onBestPathScroll() {
    var overlay = document.getElementById("bestPathBox");
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (
      overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
      1
    ) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onAnalysisScroll() {
    var overlay = document.getElementById("analysisContent");
    console.log("scroll1");
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (
      overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
      1
    ) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onTutorScroll() {
    var overlay = document.getElementById("tourReviewBox");
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (
      overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
      1
    ) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  subWrapOneOut() {
    $("#subWrapOne").fadeOut(function () {
      $("#subWrapTwo").fadeIn();
      $("#btnWrap").fadeIn();
    });
  }

  tourReviewBoxIn() {
    $("#tourReviewShade").fadeIn();
    $("#tourReviewBox").fadeIn();
    $("#closeBtn1").fadeIn();
    this.pathClickable = false;
  }

  tourReviewBoxOut() {
    $("#tourReviewShade").fadeOut();
    $("#tourReviewBox").fadeOut();
    $("#closeBtn1").fadeOut();
    this.pathClickable = true;
  }

  bestPathIn() {
    if (!this.pathClickable) {
      return;
    }
    $("#closeBtn2").fadeIn();
    this.bestPathBoxShow = true;
    $("#shade").fadeIn();
  }

  bestPathOut() {
    $("#closeBtn2").fadeOut();
    this.bestPathBoxShow = false;
    $("#shade").fadeOut();
  }

  redo() {
    let influenceProExerciseMetaId = Number(localStorage.getItem('influenceProExerciseMetaId'));
    if (!this.pathClickable || this.redoClickedStatus) {
      return;
    } else {
      this.redoClickedStatus = true;
    }
    if (this.learningPathMetaId == 13) {
      this.apiService
        .ajax({
          type: "post",
          url: "/api/pnoReset/" + this.exerciseId,
        })
        .subscribe((result) => {
          let practiceId = result.practiceId;
          let learningPathId = result.learningPathId;
          let practiceMetaId = result.practiceMetaId;
          let link = [
            learningPathId,
            practiceMetaId,
            "case-practice-p-and-o",
            this.exerciseId,
          ];
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }

          const exerciseMetaId=$('#exerciseMetaId').val()
          this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:1,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
          })
          console.log(exerciseMetaId)
          this.commonService.sendPostMessage(0,'isPractice' +'Complete')
        });
    } else {
      this.apiService.resetExercise(this.exerciseId).subscribe((result) => {
        this.apiService.saveProgress({exerciseId: this.exerciseId, progress: 0}).subscribe();
        let practiceId = result.practiceId;
        let learningPathId = result.learningPathId;
        let practiceMetaId = result.practiceMetaId;
        if (this.learningPathMetaId == 11 || this.learningPathMetaId == 403) {
          let link = [
            this.learningPathId,
            practiceMetaId,
            "case-practice-authorization",
            this.exerciseId,
          ];
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
          const exerciseMetaId=$('#exerciseMetaId').val()
          this.apiService.learingTime({learningPathMetaId:$('#learningPathMetaIdContainer').val(),module:"情景模拟",courseUnit:'',type:1,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
          })
          console.log(exerciseMetaId)
          this.commonService.sendPostMessage(0,'isPractice' +'Complete')
        } else if (this.learningPathMetaId == 14) {
          let link = [
            this.learningPathId,
            practiceMetaId,
            "case-practice-cooperation",
            this.exerciseId,
          ];
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
          const exerciseMetaId=$('#exerciseMetaId').val()
          this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:1,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
          })
          console.log(exerciseMetaId)
          this.commonService.sendPostMessage(0,'isPractice' +'Complete')
        } else if (this.learningPathMetaId == 15) {
          let link = [
            this.learningPathId,
            practiceMetaId,
            "case-practice-influence",
            this.exerciseId,
          ];
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
          const exerciseMetaId=$('#exerciseMetaId').val()
          this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:1,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
          })
          console.log(exerciseMetaId)
          this.commonService.sendPostMessage(0,'isPractice' +'Complete')
        } else if ((this.learningPathMetaId == 607 || this.learningPathMetaId == 30) && (influenceProExerciseMetaId == 60701 || influenceProExerciseMetaId == 131)) {
          let link = [
            this.learningPathId,
            practiceMetaId,
            "case-practice-influence-pro",
            this.exerciseId,
          ];
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
          const exerciseMetaId=$('#exerciseMetaId').val()
          this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:1,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
          })
          console.log(exerciseMetaId)
          this.commonService.sendPostMessage(0,'isPractice' +'Complete')
        } else if ((this.learningPathMetaId == 607 || this.learningPathMetaId == 30) && (influenceProExerciseMetaId == 60702 ||influenceProExerciseMetaId == 141)) {
          this.apiService.ajax({
            type: "get",
            url:
              "/sr/insideapi/deleteExerciseChoiceUser?exerciseId=" +
              this.exerciseId,
          }).subscribe((result) => {

            let link = ['case-practice-influence-supplier',this.learningPathId,this.practiceId,this.exerciseId,141];
            if(this.practiceMetaId === 607){
              link = ['case-practice-influence-supplier',this.learningPathId,this.practiceId,this.exerciseId,60702];
            }
            if(this.type){
              this.router.navigate(link,{queryParams:{type:'huatek'}});
            }else{
              this.router.navigate(link);
            }
          });
        }else if((this.learningPathMetaId == 607 || this.learningPathMetaId == 30) && (influenceProExerciseMetaId == 60703 || influenceProExerciseMetaId == 151)){
          this.apiService.ajax({
            type: "get",
            url:
              "/sr/insideapi/deleteExerciseChoiceUser?exerciseId=" +
              this.exerciseId,
          }).subscribe((result) => {
            let link = ['case-practice-influence-supplier',this.learningPathId,this.practiceId,this.exerciseId,151];
            if(this.practiceMetaId === 607){
              link = ['case-practice-influence-supplier',this.learningPathId,this.practiceId,this.exerciseId,60703];
            }
            if(this.type){
              this.router.navigate(link,{queryParams:{type:'huatek'}});
            }else{
              this.router.navigate(link);
            }
          });
        } else {
          let link = [
            learningPathId,
            practiceMetaId,
            "case-practice",
            this.exerciseId,
          ];
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
        }
      });
    }
  }

  analysisBoxIn(i) {
    if (!this.itemClickEnable) {
      return false;
    }
    let _this = this;
    this.currentName = this.report[i].name;
    this.currentDescription = this.report[i].description;
    this.currentTotal = this.report[i].value;
    this.currentAnalysis = this.report[i].analysis;
    $("#analysisShade").fadeIn();
    // 滚动到订端
    $("#analysisContent").scrollTop(0);
    // $('#analysisBox').fadeIn();
    this.analysisBoxShow = true;
    $("body").css("overflow-y", "hidden");
    setTimeout(function () {
      _this.starShow = true;
    }, 300);

    this.pathClickable = false;

    document.getElementById("analysisShade").ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById("analysisHead").ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById("closeBtn3").ontouchmove = function (e) {
      e.preventDefault();
    };
  }

  analysisBoxOut() {
    $("#analysisShade").fadeOut();
    this.analysisBoxShow = false;
    $("body").css("overflow-y", "scroll");
    this.starShow = false;
    this.pathClickable = true;
  }

  goToList() {
    if (this.goToListClickedStatus) {
      return;
    } else {
      this.goToListClickedStatus = true;
    }
    this.apiService
      .ajax({
        type: "get",
        url: "/api/learningpathes/" + this.learningPathId,
      })
      .subscribe((result) => {
        //转向情景列表
        let link = this.abilityConfig.getPracticeLinkList(
          result.name,
          this.learningPathId,
          this.practiceMetaId
        );

        if(localStorage.getItem('openClass')){
          console.log(this.platformLocation);
          let href = '';
          link.forEach((v)=>{
            href+='/'+v
          })
          href = href+'#isShowBack=0';
          this.platformLocation['location']['href'] = this.platformLocation['location']['origin']+href;
        }else{
          if (link.length > 0) {
            if(this.type){
              this.router.navigate(link,{queryParams:{type:'huatek'}});
            }else{
              this.router.navigate(link);
            }
          }
        }
      });
  }

  linkToPostSurvey() {
    this.apiService
      .getOrCreateLearningPath(this.learningPathMetaId)
      .subscribe((result) => {
        this.learningPath = result;
        let link = [
          "survey",
          this.learningPath.id,
          this.learningPath.subItems[4].surveyMetaId,
          1,
        ];
        this.router.navigate(link);
      });
  }


  getReport(url:string):Promise<any>{
    return this.apiService.ajax({
      type: "get",
      url: url,
    }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-report-new/case-practice-report-new.component.ts